import React from 'react';

const IntakeContext = React.createContext(null);

export {
  IntakeContext,
};